export default {
  dark: {
    "flag-cutout-color": "primary-200",
    "tier-a-list-background": "primary-500",
    "tier-a-list-preferred-background": "primary-350",
    "tier-a-list-preferred-text": "neutral-900",
    "tier-a-list-text": "neutral-900",
    "tier-pending-background": "secondary-500",
    "tier-pending-text": "primary-200",
    "username-available": "success-500",
  },
  light: {
    "flag-cutout-color": "neutral-900",
    "tier-a-list-background": "primary-350",
    "tier-a-list-preferred-background": "primary-200",
    "tier-a-list-preferred-text": "neutral-900",
    "tier-a-list-text": "neutral-900",
    "tier-pending-background": "secondary-500",
    "tier-pending-text": "primary-200",
    "username-available": "success-500",
  },
};
